module.exports = __webpack_public_path__ + "img/padlock.307966be.png";